import { render, staticRenderFns } from "./InvoiceComponent.vue?vue&type=template&id=49d143eb&scoped=true"
import script from "./InvoiceComponent.vue?vue&type=script&lang=js"
export * from "./InvoiceComponent.vue?vue&type=script&lang=js"
import style0 from "./InvoiceComponent.vue?vue&type=style&index=0&id=49d143eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d143eb",
  null
  
)

export default component.exports